// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/components/stores.scss
// module id = 77
// module chunks = 0